import { authenticatedAxiosInstance as axios } from "../axios";

const info = () => axios.get(`/core/app-info`)

export const AppApi = {
    info
}
